<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              id="farm_labor_catchs"
              clearable
              @change="showCalendar()"
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="farm_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm date-form required-date"
              v-model="date_sel"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('sowing.catch_type') }}: *</label>
            <br />
            <el-select
              id="catch_type_form"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-catchType shadow-sm"
              size="large"
              v-model="catchType"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in [
                  {
                    id: '1',
                    value: 'Siembra',
                    label: `${$t('sowing.sowing')}`,
                  },
                  {
                    id: '2',
                    value: 'Resiembra',
                    label: `${$t('sowing.replant')}`,
                  },
                ]"
                :key="item.id + item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-lg-3 col-xl-3">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validateDate"
            >
              {{ $t('common_words.generate') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert.message }}
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        :title="$t('sowing.sowing_catch')"
        v-if="showNSowingCatch && !messageAlert"
      >
        <div class="mt-4 px-3">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered not-last-td table-data"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('common_words.allotments') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('common_words.crop_variety') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('sowing.distancing_type') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong
                        >*{{ $t('sowing.total_plants_seeds_planted') }}</strong
                      >
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('sowing.sown_area') }} (Ha)</strong>
                    </th>
                    <th
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in model.nSowingCatchs" :key="index">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        @change="
                          validateArea(index - 1, model.lots_ids[index - 1]),
                            validateDensityTypeByArea(index - 1)
                        "
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="model.lots_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in lots"
                          class="select-primary"
                          :value="option.id"
                          :label="`${option.name} (${$t('common_words.area')} ${
                            option.area
                          }Ha)`"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-cropsVarieties shadow-sm"
                        size="large"
                        v-model="model.crops_varieties_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in cropVarietiesCatchs"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        @change="validateDensityTypeByArea(index - 1)"
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-distancingTypes shadow-sm"
                        size="large"
                        v-model="model.distancing_types_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in distancingTypes"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        min="1"
                        ref="totalPlantsSeedsPlanted"
                        @change="validateDensityTypeByArea(index - 1)"
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3 required-totalPlantsSeedsPlanted"
                        v-model.number="
                          model.total_plants_seeds_planted[index - 1]
                        "
                        name="sowing.total_plants_seeds_planted"
                        v-validate="modelValidations.total_plants_seeds_planted"
                        :error="
                          getError(
                            'sowing.total_plants_seeds_planted',
                            true,
                            index
                          )
                        "
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        step="0.01"
                        min="1"
                        ref="sownArea"
                        @change="
                          validateArea(index - 1, model.lots_ids[index - 1])
                        "
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3 required-sownArea"
                        v-model="model.sown_area[index - 1]"
                        name="sowing.sown_area"
                        v-validate="modelValidations.sown_area"
                        :error="getError('sowing.sown_area', true, index)"
                      >
                      </fg-input>
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="min-width: 90px"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="model.nSowingCatchs++"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="model.nSowingCatchs > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(index - 1)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="cusmtom-thead-color">
                    <td
                      class="text-center p-3 custom-header-label"
                      scope="col"
                      colspan="3"
                    >
                      {{ $t('common_words.totalized') }}
                    </td>
                    <td class="text-center p-3 custom-header-label" scope="col">
                      {{ getTotalizedPlantsSeedsPlanted() }}
                    </td>
                    <td class="text-center p-3 custom-header-label" scope="col">
                      {{ getTotalizedArea() }}
                    </td>
                    <td
                      class="text-center p-3 custom-header-label"
                      scope="col"
                    ></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <button
                class="btn btn-success custom-shadow-btn btn-filter m-4"
                @click="validateEveryDetail()"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <button
                class="btn btn-danger custom-shadow-btn btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, ifExistNumber } from 'src/util/Util';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      farms: [],
      lots: [],
      cropVarieties: [],
      cropVarietiesCatchs: [],
      distancingTypes: [],
      nursereisCatch: [],
      farm_sel: null,
      date_sel: null,
      catchType: null,
      isShowCalendar: false,
      messageAlert: null,
      showNSowingCatch: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      model: {
        id: null,
        sowing_catch_header_id: null,
        sowing_catch_detail_id: [],
        delete_sowing_catch_header_id: null,
        delete_sowing_catch_detail_ids: [],
        nSowingCatchs: 1,
        farm_id: null,
        user_id: null,
        date_save: null,
        catch_type: null,
        lots_ids: [],
        crops_varieties_ids: [],
        distancing_types_ids: [],
        total_plants_seeds_planted: [],
        sown_area: [],
      },
      modelValidations: {
        total_plants_seeds_planted: {
          min_value: 0,
          numeric: true,
          required: true,
        },
        sown_area: {
          min_value: 0,
          decimal: true,
          required: true,
        },
      },
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinForm, MixinMenu],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  methods: {
    validateDate() {
      if (!isset(this.farm_sel)) return this.validationInputsRequired('farm');
      else if (this.date_sel == null)
        return this.validationInputsRequired('date');
      else if (this.calendar_sel == null)
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      else if (this.catchType == null)
        return this.validationInputsRequired('catchType');
      else {
        this.messageAlert = null;
        this.showNSowingCatch = true;
        this.cleanForm();
        this.loadData();
      }
    },
    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.calendar_sel = null;
      this.showNSowingCatch = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.farm_sel
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }
      this.isShowCalendar = false;
    },
    cleanForm() {
      if (this.messageAlert && !this.messageAlert.show)
        this.messageAlert = null;
      this.model.farm_id = null;
      this.model.date_save = null;
      this.model.user_id = null;
      this.model.catch_type = null;
      this.model.nSowingCatchs = 1;
      this.model.lots_ids = [];
      this.model.crops_varieties_ids = [];
      this.model.distancing_types_ids = [];
      this.model.total_plants_seeds_planted = [];
      this.model.sown_area = [];
      this.model.sowing_catch_header_id = null;
      this.model.sowing_catch_detail_id = [];
      this.model.delete_sowing_catch_header_id = null;
      this.model.delete_sowing_catch_detail_ids = [];
      this.nursereisCatch = [];
      this.cropVarietiesCatchs = [];
    },
    loadData() {
      this.showHideLoading(true);
      this.showNSowingCatch = true;
      let data = {
        farm_id: this.farm_sel,
        date_save: this.date_sel,
        catch_type: this.catchType,
        user_id: this.$store.state.auth.user.id,
        route: 'sowing/sowingcatch/list',
      };
      let dataNurseryCatch = {
        farm_id: this.farm_sel,
        user_id: this.$store.state.auth.user.id,
        route: 'nursery/nurserycatch/list',
      };
      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.farm_sel),
        Axios.postMasters(dataNurseryCatch),
        Axios.postMasters(data),
      ])
        .then(([responseLots, responseNurseryCatch, responseSowingCatch]) => {
          let sowingCatchs = responseSowingCatch.data.data;
          this.lots = responseLots.data.data;
          this.nursereisCatch = responseNurseryCatch.data.data;
          let cropVarietiesCatchsIds = [];
          if(isset(this.nursereisCatch)) {
            this.nursereisCatch[0].nursery_details.forEach((catchs) => {
            cropVarietiesCatchsIds.push(catchs);
          });
          this.cropVarietiesCatchs = this.cropVarieties.filter((varieties) =>
            cropVarietiesCatchsIds.some(
              (detail) => detail.crop_variety_id === varieties.id
            )
          );
          }
        
          if (isset(sowingCatchs)) {
            this.model.sowing_catch_header_id = sowingCatchs[0].id;
            this.model.farm_id = sowingCatchs[0].farm_id;
            this.model.user_id = sowingCatchs[0].user_id;
            this.model.catch_type = sowingCatchs[0].catch_type;
            this.model.date_save = sowingCatchs[0].date_save;
            this.model.nSowingCatchs = 0;
            sowingCatchs[0].sowing_details.forEach((sowingDetail) => {
              this.model.sowing_catch_detail_id.push(sowingDetail.id);
              this.model.lots_ids.push(sowingDetail.lot_id);
              this.model.crops_varieties_ids.push(sowingDetail.crop_variety_id);
              this.model.distancing_types_ids.push(
                sowingDetail.distancing_type_id
              );
              this.model.total_plants_seeds_planted.push(
                sowingDetail.total_plants_seeds
              );
              this.model.sown_area.push(sowingDetail.area);
              this.model.nSowingCatchs++;
            });
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
    handleDelete(index) {
      if (
        isset(this.model.lots_ids[index]) &&
        isset(this.model.crops_varieties_ids[index]) &&
        isset(this.model.distancing_types_ids[index])
      ) {
        SweetAlert.delete(this.getDataRegisterForDelete(index)).then(
          (result) => {
            if (result.value) {
              this.registerSelectDelete(index);
            }
          }
        );
      } else {
        this.registerSelectDelete(index);
      }
    },
    getDataRegisterForDelete(index) {
      const lotId = this.model.lots_ids[index];
      const cropVarietyId = this.model.crops_varieties_ids[index];
      const distancingTipeId = this.model.distancing_types_ids[index];

      const lotSearch = this.lots.find((lot) => lot.id === lotId);
      const cropVarietySearch = this.cropVarieties.find(
        (cropVariety) => cropVariety.id === cropVarietyId
      );
      const distancingTypeSearch = this.distancingTypes.find(
        (distancingType) => distancingType.id === distancingTipeId
      );

      return `${i18n.t('common_words.allotment')}: 
        ${lotSearch.name} - ${cropVarietySearch.name} - 
        ${distancingTypeSearch.name}`;
    },
    setDeleteSowingCatchs(index) {
      if (isset(this.model.sowing_catch_detail_id[index])) {
        this.model.delete_sowing_catch_detail_ids.push(
          this.model.sowing_catch_detail_id[index]
        );
      }
    },
    registerSelectDelete(index) {
      this.setDeleteSowingCatchs(index);
      this.model.sowing_catch_detail_id.splice(index, 1);
      this.model.lots_ids.splice(index, 1);
      this.model.crops_varieties_ids.splice(index, 1);
      this.model.distancing_types_ids.splice(index, 1);
      this.model.total_plants_seeds_planted.splice(index, 1);
      this.model.sown_area.splice(index, 1);
      this.model.nSowingCatchs--;
    },
    validateEveryDetail() {
      for (let i = 0; i < this.model.nSowingCatchs; i++) {
        if (!isset(this.model.lots_ids[i]))
          return this.validationInputsRequired('lots');
        else if (!isset(this.model.crops_varieties_ids[i]))
          return this.validationInputsRequired('cropsVarieties');
        else if (!isset(this.model.distancing_types_ids[i]))
          return this.validationInputsRequired('distancingTypes');
        else if (!isset(this.model.total_plants_seeds_planted[i]))
          return this.validationInputsRequired('totalPlantsSeedsPlanted');
        else if (!ifExistNumber(this.model.sown_area[i]))
          return this.validationInputsRequired('sownArea');
      }
      this.storeUpdateSowingCatchs();
    },
    confirmDelete() {
      if (this.model.sowing_catch_header_id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.sowing.delete_sowing_catchs'),
          i18n.t('common_words.all_associated_records2')
        ).then((result) => {
          if (result.value) {
            this.deleteSowingCatchs();
          }
        });
      } else this.cleanForm();
    },
    deleteSowingCatchs() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'sowing/sowingcatch/delete';
        this.model.id = this.model.sowing_catch_header_id;
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.showNSowingCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t(
                'show_notification.sowing.delete_sowing_catchs_successful'
              ),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },
    storeUpdateSowingCatchs() {
      this.setDataByDefault();
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'sowing/sowingcatch/store';
        if (isset(this.model.sowing_catch_header_id)) {
          this.model.route = 'sowing/sowingcatch/update';
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showNSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showNSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
          this.showHideLoading();
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },
    setDataByDefault() {
      this.model.farm_id = this.farm_sel;
      this.model.date_save = this.date_sel;
      this.model.catch_type = this.catchType;
      this.model.user_id = this.$store.state.auth.user.id;
    },
    validateArea(index, lotId) {
      let lotArea = 0;
      for (let i = 0; i < this.model.nSowingCatchs; i++) {
        let lotSearch = this.lots.find((lot) => lot.id === lotId);
        if (isset(lotSearch)) {
          if (this.model.lots_ids[i] === lotId) {
            lotArea = lotArea + parseFloat(this.model.sown_area[i]);
            if (lotArea > lotSearch.area) {
              SweetAlert.warning(i18n.t('sweet_alert.sowing.error_lot_area'));
              this.$set(this.model.sown_area, index, null);
              this.$set(this.model.total_plants_seeds_planted, index, null);
            }
          }
        }
      }
    },
    formatNumber(value) {
      return Formatter.formatNumber(value);
    },
    getTotalizedPlantsSeedsPlanted() {
      let totalized = 0;
      for (let index = 0; index < this.model.nSowingCatchs; index++) {
        if (isset(this.model.total_plants_seeds_planted[index])) {
          totalized = totalized + this.model.total_plants_seeds_planted[index];
        }
      }
      
      return this.formatNumber(totalized);
    },
    getTotalizedArea() {
      let totalized = 0;
      for (let index = 0; index < this.model.nSowingCatchs; index++) {
        if (ifExistNumber(this.model.sown_area[index])) {
          totalized = totalized + Number(this.model.sown_area[index]);
        }
      }

      // return this.formatNumber(totalized);
      return totalized.toFixed(2);
    },
    validateDensityTypeByArea(index) {
      if (
        isset(this.model.distancing_types_ids[index]) &&
        isset(this.model.lots_ids[index])
      ) {
        if (isset(this.model.total_plants_seeds_planted[index])) {
          const distancingTypeSelected = this.distancingTypes.filter(
            (distancingType) =>
              distancingType.id == this.model.distancing_types_ids[index]
          );
          let long = distancingTypeSelected[0].long;
          let wide = distancingTypeSelected[0].wide;
          let calculatedArea = 0;
          if (long != 0 && wide != 0) {
            let density = parseFloat(10000 / (long * wide));
            calculatedArea = parseFloat(
              this.model.total_plants_seeds_planted[index] / density
            ).toFixed(2);
          }
          this.$set(this.model.sown_area, index, calculatedArea);
          this.validateArea(index, this.model.lots_ids[index]);
        }
      }
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('cropvarieties'),
        Axios.getMasters('sowing/distancingtype'),
      ])
        .then(([responseFarm, responseCropVariety, responseDistancingType]) => {
          this.farms = responseFarm.data.data;
          this.cropVarieties = responseCropVariety.data.data;
          this.distancingTypes = responseDistancingType.data.data;

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('distancingtype');
  },
  destroyed() {
    this.deselectedItemOnMenu('distancingtype');
  },
};
</script>
